import { useLazyQuery } from '@apollo/client/react/hooks';
import { useCallback, useEffect } from 'react';
import { GET_VENUES } from '../../graphql/venues';

export const useVenues = () => {
  const [fetchVenues, { data, loading, error, refetch }] = useLazyQuery(
    GET_VENUES,
    { fetchPolicy: 'no-cache' },
  );

  // When orgId is provided, it overrides the `organization` Apollo context
  // header the auth link would otherwise inject from the persisted session.
  // Use this from flows that select an org before committing it to session
  // (e.g. device-selection org switch). Without it, the request relies on
  // session.currentOrganization being committed before fire time.
  const getVenues = useCallback(
    (orgId?: string) =>
      fetchVenues(
        orgId ? { context: { headers: { organization: orgId } } } : undefined,
      ),
    [fetchVenues],
  );

  useEffect(() => {
    fetchVenues();
  }, [fetchVenues]);

  return {
    venues: data?.venues,
    loading,
    error,
    refetch,
    getVenues,
  };
};
